import { makeStyles } from '@material-ui/core';
import { baseColors } from '@ncr-retail/mui-theme';

const baseColor = baseColors();

export const styles = makeStyles(() => ({
  commandLine: {
    margin: 18,
    color: baseColor.tangaroa,
  },
}));
